/**
 * Create a `/c/{identifier}` pathname with the given identifier.
 * @param identifier - The identifier to use.
 * @returns The pathname.
 * @example
 * ```ts
 * const url = createCategoryPathname('123');
 * console.log(url); // /c/123
 * ```
 */
export const createCategoryPathname = (identifier: string): string =>
  `/c/${identifier}`;
